import { css } from "@emotion/react";
import colors from "assets/css/colors";
import { columnGap8Css } from "assets/css/gaps.css";

export const gotoLabelCss = [
  columnGap8Css,
  css`
    display: flex;
    align-self: stretch;
    align-items: center;
  `,
];

export const baseInputCss = css`
  box-sizing: border-box;
  width: 40px;
  border: 1px solid ${colors.mainBlack};
  border-radius: 2px;

  &:focus {
    outline: none;
    border: 1px solid ${colors.mainBlue};
  }

  &:disabled {
    background-color: ${colors.bgGrey};
    border: 1px solid ${colors.strokeGrey};
    color: ${colors.grey};
  }
`;

const inputErrorCss = [
  baseInputCss,
  css`
    border: 1px solid ${colors.red};
    color: ${colors.textBlack};
    &:focus {
      border: 1px solid ${colors.red};
    }
  `,
];

export function inputCss({ error }) {
  return error ? inputErrorCss : baseInputCss;
}
